import {detect} from 'detect-browser';
import Component from '../abstracts/Component';
import ajaxAction from '../utils/ajaxUtil';

export default class HeaderComponent extends Component {

  get SELECTORS() {
    return {
      main: '.main-header',
      reverse: '.main-header.reverse',
      header: '.main-header',
      mainWrapper: '[role=main]',
      heroWidget: '.c-hero',
      minicart: '[data-minicart]',
      minicartBox: '.js-cart-dropdown',
      layerProducts: '[data-layer-products]',
      wishlist: '[data-wishlist]',
      wishlistBox: '.js-wishlist-dropdown',
      searchIcon: '.header-actions .action.search'
    };
  }

  get CLASSES() {
    return {
      hidden: 'is-hidden',
      expanded: 'expanded',
      collapsed: 'collapsed',
      top: 'is-top',
      headerTransparent: 'header-transparent',
    };
  }

  constructor() {
    super();
    // ajax
    this.ajaxAction = new ajaxAction();
    this.minicart = document.querySelector(this.SELECTORS.minicart);
    this.wishlist = document.querySelector(this.SELECTORS.wishlist);
    this.searchIcon = document.querySelector(this.SELECTORS.searchIcon);
  }


  hideLogoOnScroll() {
    let header = document.querySelector(this.SELECTORS.header);

    this.$on(this.$customEvents.HEADER_EVENTS.collapsed, () => {
      header.classList.add(this.CLASSES.collapsed);
      header.classList.remove(this.CLASSES.expanded);
    });

  }


  showLogoOnScroll() {
    let header = document.querySelector(this.SELECTORS.header);

    this.$on(this.$customEvents.HEADER_EVENTS.expanded, () => {
      header.classList.add(this.CLASSES.expanded);
      header.classList.remove(this.CLASSES.collapsed);
    });

  }


  expandHeader() {
    const ctx = this;
    let top = 0;
    let header = document.querySelector(this.SELECTORS.header);
    let headerH = header.clientHeight;
    let pageLanding = $("body").hasClass("t-product");
    let deactivateAtY;

    $(window).scroll(function() {
      let scroll = $(window).scrollTop();

      if( document.querySelector(ctx.SELECTORS.heroWidget) !== null ) {
        let hero = document.querySelector(ctx.SELECTORS.heroWidget);
        deactivateAtY = hero.clientHeight / 2;
      } else {
        deactivateAtY = 500;
      }

      if(pageLanding) {
        if(top < scroll) {
            ctx.$emit(ctx.$customEvents.HEADER_EVENTS.expanded,{scroll: scroll,top: top});
        }
        if(scroll < top) {
            ctx.$emit(ctx.$customEvents.HEADER_EVENTS.collapsed,{scroll: scroll,top: top});
        }
      } else {
        if(scroll < top) {
            ctx.$emit(ctx.$customEvents.HEADER_EVENTS.expanded,{scroll: scroll,top: top});
        }
        if(top < scroll) {
            ctx.$emit(ctx.$customEvents.HEADER_EVENTS.collapsed,{scroll: scroll,top: top});
        }
      }

      top = scroll;

    });

  }

  collapseHeader() {
    const ctx = this;
    let top = 0;
    let header = document.querySelector(this.SELECTORS.header);
    let headerH = header.clientHeight;

    $(window).scroll(function() {
      let scroll = $(window).scrollTop();
      let deactivateAtY = 500;

      if(scroll > top && scroll > headerH) {
        ctx.$emit(ctx.$customEvents.HEADER_EVENTS.collapsed,{scroll: scroll,top: top});
      }

      if(top > scroll) {
        ctx.$emit(ctx.$customEvents.HEADER_EVENTS.expanded,{scroll: scroll,top: top});
      }

      top = scroll;

    });

  }

  elementHandlingObserver(selector,callback){
    let ctx = this;
    // observer listener
    function listener(records) {
      records.forEach(function (record) {
        let list = record.addedNodes;
        let i = list.length - 1;
        for ( ; i > -1; i-- ) {
          // if i find a new component
          if ( typeof list[i] == 'object' && list[i].nodeType == '1') {
            if (list[i].getAttribute('class') !== null  ) {
              // if is the xgen part
              if (list[i].getAttribute('class').includes('XGen')) {
                // ctx.checkMinicartHeight();
                if (typeof callback !== "undefined") {
                  ctx.ajaxAction.executeFunctionByName(callback, ctx);
                }
              }
            }
          }
        }
      });
    }
    // define observer
    let observer = new MutationObserver(listener);
    // nodes to observe
    let sizeNode = document.querySelector(selector);
    if ( typeof sizeNode != 'undefined' && sizeNode != null ) {
      // loop to observe each node
      observer.observe(sizeNode, { childList: true, subtree: true });
    }
  }

  checkLayerHeight(elem) {
    // no products or no elem , no reducing
    if (elem == null) return false;
    let layerProducts = elem.querySelector(this.SELECTORS.layerProducts);
    if (layerProducts == null) return false;
    // reset
    elem.style.height = 'auto';
    elem.style.maxHeight = 'auto';
    elem.style.overflowY = 'hidden';
    // set vars
    let wh = window.innerHeight || document.documentElement.clientHeight;
    let layerTopOffset = elem.getBoundingClientRect().top;
    let layerHeaderHeight = elem.querySelector("header") != null ? elem.querySelector("header").clientHeight : 0;
    let layerFooter = elem.querySelector("footer");
    let widgetEl = (layerFooter != null && layerFooter.nextElementSibling != null) ? layerFooter.nextElementSibling : null;
    // put max height to container
    let elNewHeight = wh - layerTopOffset;
    // check overflow
    if (elem.clientHeight > elNewHeight) {
      // I have to reduce height
      let layerFooterHeight = layerFooter != null ? layerFooter.clientHeight : 0;
      let widgetHeight = widgetEl != null ? widgetEl.clientHeight : 0;
      let remainingHeight = elNewHeight - layerHeaderHeight - layerFooterHeight - widgetHeight ;
      if (remainingHeight < 180) {
        remainingHeight = 180;
        elem.style.overflowY = 'scroll';
      } else {
        elem.style.overflowY = 'hidden';
      }
      // put style into products
      layerProducts.style.height = remainingHeight+'px';
      layerProducts.classList.add('reduced');
      // put container style AFTERRR
      elem.style.height = elNewHeight +'px';
    } else {
      // reset height
      layerProducts.removeAttribute('style');
      layerProducts.classList.remove('reduced');
      //  put container style AFTERRR
      elem.style.maxHeight = elNewHeight +'px';
    }
  }

  checkMinicartHeight() {
    // throw it
    this.checkLayerHeight(this.minicart);
  }

  checkWishlistHeight() {
    // throw it
    this.checkLayerHeight(this.wishlist);
  }

  resetLayerBox(box) {
    if (box === null) return false;
    this.resetElemStyle(box);
    let layerProducts = box.querySelector(this.SELECTORS.layerProducts);
    this.resetElemStyle(layerProducts);
  }

  resetElemStyle(el) {
    if (typeof el === 'undefined' || el == null) return false;
    // reset inline style
    el.removeAttribute('style');
  }

  bindEvents() {
    //
    let ctx = this;
    //
    this.$on(this.$customEvents.BURGER_EVENTS.click, () => {
      $(this.SELECTORS.main).toggleClass(this.CLASSES.top);
    });
    // enter the minicart
    this.$on('mouseenter.minicart', ({event}) => {
      // recalculate height
      ctx.checkMinicartHeight();
    }, 'body', this.SELECTORS.minicartBox);
    // exit the minicart
    this.$on('mouseleave.minicart', ({event}) => {
      // reset after 1/2 sec
      setTimeout(function (){
        ctx.resetLayerBox(ctx.minicart);
      },200);
    }, 'body', this.SELECTORS.minicartBox);

    // enter the wishlist
    this.$on('mouseenter.wishlist', ({event}) => {
      // recalculate height
      ctx.checkWishlistHeight();
    }, 'body', this.SELECTORS.wishlistBox);
    // exit the wishlist
    this.$on('mouseleave.wishlist', ({event}) => {
      // reset after 1/2 sec
      setTimeout(function (){
        ctx.resetLayerBox(ctx.wishlist);
      },200);
    }, 'body', this.SELECTORS.wishlistBox);

  }

  mainIeFixes() {
    const main = document.querySelector('main');
    const header = document.querySelector('.main-header');
    const logo = document.querySelector('.logo');
    const nav = document.querySelector('.navigation');
    const bfBar = document.querySelector('.benefit-bar');

    main.classList.add('no-transform');
    header.classList.add('is-fixed');
    bfBar.classList.add('is-fixed');

    if($('.filters').length > 0) {
      const filters = document.querySelector('.filters');
      filters.classList.add('is-fixed');
      main.style.paddingTop = `${bfBar.clientHeight + header.clientHeight + filters.clientHeight}px`

    } else {
      if (header.classList.contains('collapse-reverse')) {
        main.style.paddingTop = `${bfBar.clientHeight + nav.clientHeight}px`
      } else {
        main.style.paddingTop = `${bfBar.clientHeight + nav.clientHeight + logo.clientHeight}px`
      }
    }

  }

  render() {
    this.log('rendering...');
    let header = document.querySelector(this.SELECTORS.header);
    if (header === null) return;
    let browser = detect();
    if (browser && browser.name === 'ie') this.mainIeFixes();

    this.bindEvents();

    if ( $('.collapse-reverse').length && this.$matchMedia(null, 'lg')) {
      this.expandHeader();
    } else {
      this.collapseHeader();
    }

    if($('.c-half-media').length) {
      $(this.SELECTORS.mainWrapper).addClass('small-pad');
    }

    this.hideLogoOnScroll();
    this.showLogoOnScroll();
    // xgen part
    if ( this.$matchMedia(null, 'sm')) {
      this.elementHandlingObserver(this.SELECTORS.minicart,"checkMinicartHeight");
      this.elementHandlingObserver(this.SELECTORS.wishlist,"checkWishlistHeight");
    }
    // on desktop i need the expanded class
    if ( header.classList.contains(this.CLASSES.headerTransparent) && this.$matchMedia(null, 'lg')) {
      let top = 0;
      let scroll = $(window).scrollTop();
      this.$emit(this.$customEvents.HEADER_EVENTS.expanded,{scroll: scroll,top: top});
      // I need to hide search icon
      if (this.searchIcon !== null) {
        this.searchIcon.classList.add('hidden');
      }
    }
  }
}
